import {
  CellContext,
  ColumnDef,
  createColumnHelper
} from "@tanstack/react-table";
import React from "react";

import { ITerminology } from "src/library/utils/string-manipulations/tokenize-string";
import { IList } from "src/core/lists/api/lists.api";
import { customCreateColumnHelper } from "src/core/dashboard/components/widgets/table/customColumnHelper";
import { Text } from "src/library/components/Text";
import { formatDropName } from "src/core/drops/utils/format-drop-name";

export interface IListTableColumns {
  terminology: ITerminology;
  actionButton: (info: CellContext<IList, unknown>) => React.ReactNode;
  pricesVisible: boolean;
  adminView?: boolean;
}

export const listsTableColumns = (params: IListTableColumns) => {
  const customColumnHelper = customCreateColumnHelper<IList>();
  const columnHelper = createColumnHelper<IList>();

  const columns = [

    customColumnHelper.customerColumn(columnHelper, "branch.customer", { meta: { filter: { filterType: "string" } } }, params.terminology),

    customColumnHelper.standardTextColumn(columnHelper, "branch", {
      header: params.terminology.drop.singular.text,
      enableSorting: false,
      cell: info => (
        <Text>
          {formatDropName(info.row.original.branch)}
        </Text>
      )
    }),

    customColumnHelper.standardTextColumn(columnHelper, "name", {
      header: "List Name",
      enableColumnFilter: true,
      minSize: 100
    }),
    customColumnHelper.scheduleColumn(columnHelper, params.terminology),
    customColumnHelper.listQuantityColumn(columnHelper),
    customColumnHelper.scheduleStatusColumn(columnHelper, params.terminology),
    customColumnHelper.dateColumn(columnHelper, "createdAt", { header: "Created" }),
    customColumnHelper.dateColumn(columnHelper, "updatedAt", { header: "Last Updated" }),

    customColumnHelper.actionColumn(columnHelper, params.actionButton, { size: 200 })
  ];

  if (params.pricesVisible) {
    columns.splice(2, 0, customColumnHelper.listTotalColumn(columnHelper));
  }

  if (!params.adminView) {
    return columns.filter(col => (col.id !== "branch" && col.id !== "branch.customer")) as Array<ColumnDef<IList, keyof IList>>;
  }

  return columns as Array<ColumnDef<IList, keyof IList>>;
};
